import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=5ccbe440&functional=true"
import script from "./Tiles.vue?vue&type=script&lang=js"
export * from "./Tiles.vue?vue&type=script&lang=js"
import style0 from "./Tiles.vue?vue&type=style&index=0&id=5ccbe440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports